module.exports = __webpack_public_path__ + "static/media/user-big.c411632b.png";